import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n\n  ", ":hover & {\n    border-color: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  display: block;\n  background-color: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  align-self: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  margin-top: 5px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  margin-right: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          border: 1px solid ", ";\n          padding: 20px;\n          border-radius: 10px;\n          margin-bottom: 20px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n\n          box-shadow: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          min-height: 64px;\n          padding: 20px 0;\n          border-bottom: 1px solid ", ";\n\n          &:last-child {\n            border-bottom: none;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { SELECTION_LIST_ROW } from '../utils/testing/TestIDs';
import styled, { css } from '../utils/styling/styled-components';
var Row = styled.div(_templateObject(), function (_ref) {
  var _ref$rowStyle = _ref.rowStyle,
      rowStyle = _ref$rowStyle === void 0 ? 'default' : _ref$rowStyle,
      theme = _ref.theme,
      isChecked = _ref.isChecked;
  return rowStyle === 'default' ? css(_templateObject2(), theme.colors.ivory) : css(_templateObject3(), theme.colors.ivory, isChecked ? theme.shadows.lgMedium : 'none');
});
var RowContent = styled.div(_templateObject4());
var Label = styled.div(_templateObject5());
var Subtext = styled.div(_templateObject6(), function (props) {
  return props.theme.colors.stone;
});
var IconWrapper = styled.div(_templateObject7(), function (_ref2) {
  var align = _ref2.align;

  switch (align) {
    case 'top':
      return 'flex-start';

    case 'bottom':
      return 'flex-bottom';

    default:
      return 'center';
  }
});

var CheckedIcon = function CheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.6641 11.6461L9.80699 14.2833L15.0814 7.99756",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var Checked = styled(CheckedIcon)(_templateObject8(), function (props) {
  return props.theme.colors.green;
});
var Unchecked = styled.div(_templateObject9(), function (props) {
  return props.theme.colors.stoneLight;
}, Row, function (props) {
  return props.theme.colors.stone;
});
export var SelectionListRow = function SelectionListRow(_ref3) {
  var option = _ref3.option,
      rowStyle = _ref3.rowStyle,
      isChecked = _ref3.isChecked,
      onSelect = _ref3.onSelect,
      children = _ref3.children,
      alignCheckmark = _ref3.alignCheckmark;

  var handleSelect = function handleSelect() {
    onSelect(option);
  };

  return /*#__PURE__*/React.createElement(Row, {
    rowStyle: rowStyle,
    onClick: handleSelect,
    "data-testid": "".concat(SELECTION_LIST_ROW, "_").concat(option.value),
    isChecked: isChecked
  }, /*#__PURE__*/React.createElement(RowContent, null, children || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, null, option.label), option.subtext && /*#__PURE__*/React.createElement(Subtext, null, option.subtext))), /*#__PURE__*/React.createElement(IconWrapper, {
    align: alignCheckmark
  }, isChecked ? /*#__PURE__*/React.createElement(Checked, null) : /*#__PURE__*/React.createElement(Unchecked, null)));
};